// Reset to zero - live data will be calculated from actual sold vehicles in Supabase
export const soldVehiclesCount = 0;

export const donationPerVehicle = 100;

export const totalDonated = soldVehiclesCount * donationPerVehicle;

// Note: These are example rescue stories based on Oregon Dog Rescue's mission.
// For official rescue counts and current dogs available, visit oregondogrescue.org
export const rescueStories = [
  {
    id: 1,
    name: 'Biscuit',
    breed: 'Golden Retriever Mix',
    rescueDate: 'January 2025',
    adoptedDate: 'February 2025',
    status: 'adopted' as const,
    story: 'Biscuit was found wandering along Highway 101 near Seaside, severely underweight and scared. Thanks to Oregon Dog Rescue, he received medical care, a warm bed, and endless love. Within weeks, Biscuit transformed into the happiest pup — and found his forever family in Astoria.',
    image: 'https://public.readdy.ai/ai/img_res/d9daab1fbfe226bbaa2bf67a64e3156c.jpg',
  },
  {
    id: 2,
    name: 'Luna',
    breed: 'Border Collie',
    rescueDate: 'November 2024',
    adoptedDate: 'December 2024',
    status: 'adopted' as const,
    story: 'Luna was surrendered by an owner who could no longer care for her. She arrived timid and anxious, but the dedicated volunteers at Oregon Dog Rescue worked with her daily. Luna blossomed into a confident, playful girl and was adopted by a family with a big backyard in Warrenton.',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20border%20collie%20dog%20with%20black%20and%20white%20fur%20looking%20happy%20and%20playful%20in%20green%20grass%20outdoor%20setting%20rescue%20dog%20portrait%20professional%20pet%20photography%20warm%20natural%20lighting%20gentle%20expression&width=600&height=600&seq=rescue-dog-luna-002&orientation=squarish',
  },
  {
    id: 3,
    name: 'Copper',
    breed: 'Beagle',
    rescueDate: 'December 2024',
    adoptedDate: 'January 2025',
    status: 'adopted' as const,
    story: 'Copper was rescued from a neglect situation in rural Clatsop County. Despite everything, his tail never stopped wagging. After receiving veterinary care and socialization at Oregon Dog Rescue, Copper found a loving home with a retired couple who take him on daily beach walks.',
    image: 'https://readdy.ai/api/search-image?query=cute%20beagle%20dog%20with%20tricolor%20coat%20sitting%20happily%20looking%20at%20camera%20with%20big%20brown%20eyes%20rescue%20dog%20portrait%20professional%20pet%20photography%20soft%20warm%20lighting%20cozy%20indoor%20shelter%20setting&width=600&height=600&seq=rescue-dog-copper-003&orientation=squarish',
  },
  {
    id: 4,
    name: 'Maple',
    breed: 'Australian Shepherd',
    rescueDate: 'February 2025',
    adoptedDate: null,
    status: 'available' as const,
    story: 'Maple is a young Australian Shepherd with boundless energy and the sweetest personality. She was found as a stray near Tillamook and is currently thriving in foster care through Oregon Dog Rescue. Maple loves fetch, belly rubs, and is looking for her forever home.',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20australian%20shepherd%20dog%20with%20merle%20coat%20blue%20eyes%20looking%20adorable%20and%20hopeful%20in%20outdoor%20setting%20rescue%20dog%20portrait%20professional%20pet%20photography%20natural%20lighting%20green%20grass%20background&width=600&height=600&seq=rescue-dog-maple-004&orientation=squarish',
  },
  {
    id: 5,
    name: 'Bear',
    breed: 'Labrador Mix',
    rescueDate: 'October 2024',
    adoptedDate: 'November 2024',
    status: 'adopted' as const,
    story: 'Bear was a big, gentle soul found abandoned at a campground near Long Beach. He was scared of everything at first, but the patient team at Oregon Dog Rescue helped him learn to trust again. Bear now lives with a family of five and is the neighborhood favorite.',
    image: 'https://readdy.ai/api/search-image?query=large%20friendly%20black%20labrador%20mix%20dog%20with%20warm%20brown%20eyes%20lying%20down%20relaxed%20happy%20expression%20rescue%20dog%20portrait%20professional%20pet%20photography%20soft%20indoor%20lighting%20cozy%20setting&width=600&height=600&seq=rescue-dog-bear-005&orientation=squarish',
  },
  {
    id: 6,
    name: 'Daisy',
    breed: 'Pit Bull Terrier',
    rescueDate: 'March 2025',
    adoptedDate: null,
    status: 'available' as const,
    story: 'Daisy is a sweet, gentle pit bull who was rescued from a hoarding situation. Despite her rough start, she is incredibly affectionate and loves nothing more than curling up on the couch. She is currently in foster care and ready to find her forever family.',
    image: 'https://readdy.ai/api/search-image?query=sweet%20pit%20bull%20terrier%20dog%20with%20brindle%20coat%20smiling%20happy%20face%20sitting%20in%20comfortable%20setting%20rescue%20dog%20portrait%20professional%20pet%20photography%20warm%20soft%20lighting%20gentle%20loving%20expression&width=600&height=600&seq=rescue-dog-daisy-006&orientation=squarish',
  },
];

// Starting fresh - milestones will grow as real vehicles are sold
export const impactMilestones = [
  { 
    date: 'Today', 
    label: 'Partnership Launched', 
    description: 'Rockhound Auto and Oregon Dog Rescue have partnered to donate $100 per vehicle sold. Every sale helps rescue, rehabilitate, and rehome dogs in need.', 
    count: 0 
  },
];